// The verified tracking pages require entering the code on the carrier's site.
const officialTrackingPage = (url) => (trackingNumber) => (
  typeof trackingNumber === 'string' && trackingNumber.trim() ? url : null
);

const CARRIERS = {
  post: { label: 'پست', trackUrl: () => null },
  sahapik: { label: 'سها پیک', trackUrl: () => null },
  tipax: {
    label: 'تیپاکس',
    trackUrl: officialTrackingPage('https://tipaxco.com/tracking'),
  },
  chapar: {
    label: 'چاپار',
    trackUrl: officialTrackingPage('https://www.chaparnet.com/track'),
  },
};

export const getCarrier = (code) => {
  const key = typeof code === 'string' ? code.trim().toLowerCase() : '';
  return Object.hasOwn(CARRIERS, key)
    ? CARRIERS[key]
    : { label: code, trackUrl: () => null };
};
